module.exports = __webpack_public_path__ + "static/media/background.a12ad4b4.png";